import * as types from '../constants/ActionTypes';
import { merge, assoc, dissoc, omit } from 'ramda';

const messages = (state = {}, action) => {
  switch (action.type) {
    case types.GET_MESSAGES_SUCCESS:
      return merge(state, action.payload.messages);
    case types.ADD_LOCAL_MESSAGE: {
      const { message } = action.payload;
      return assoc(message.id, { ...message, isLocal: true }, state);
    }
    case types.UPDATE_LOCAL_MESSAGE: {
      const { id, _id } = action.payload;

      return {
        ...state,
        [id]: {
          ...state[id],
          _id,
        },
      };
    }
    case types.MESSAGE_RECEIVED_SUCCESS: {
      return merge(state, action.payload.messages);
    }
    case types.ADD_MESSAGE_FAIL: {
      const { messageId } = action.payload;
      return {
        ...state,
        [messageId]: {
          ...state[messageId],
          isFailed: true,
        },
      };
    }
    case types.REMOVE_MESSAGE: {
      const { id } = action.payload.message;
      return dissoc(id, state);
    }
    case types.REMOVE_MESSAGES: {
      const { messageIds } = action.payload;
      return omit(messageIds, state);
    }
    default:
      return state;
  }
};

export default messages;
